

import { computed, ref } from 'vue'
import moment from 'moment';
import {FilterMatchMode, FilterOperator} from "primevue/api";
import router from "@/router";
import {useToast} from "primevue/usetoast";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import { useConfirm } from "primevue/useconfirm";
import {BaoCaoVeSinhNuocSach} from "@/models/baoCaoVeSinhNuocSach";
import CDCRepository from "@/services/CDCRepository";
import {BaoCaoThongKeTiemVacxin} from "@/models/baoCaoThongKeTiemVacxin";
import {BaoCaoTinhHinhSDVacxinVaDCTC} from "@/models/baoCaoTinhHinhSDVacxinVaDCTC";
import {BaoCaoSangLocBenhKLN} from "@/models/baoCaoSangLocBenhKLN";
import {DanhSachBaoCaoThang} from "@/models/danhSachBaoCaoThang";
import axios from "axios";


export default {
  setup() {
    const confirm = useConfirm();
    const toast = useToast();
    const store = useStore();
    const date = ref();
    const service = ref("");
    const router = useRouter();
    const dateSanLoc = ref();
    const baoCao = ref({} as BaoCaoSangLocBenhKLN);
    const listBaoCao = ref([] as DanhSachBaoCaoThang[]);
    const baoCaoSanLoc = ref(false);
    const loadingData = ref(false);
    console.log("####################@@@@@@@@@@@@@@@@@@@@@ baoCaoCoSoLaoDong aaaa: ");
    const team = computed(() => store.state.team);
    // const initDb = () => {
    //   baoCao.value.baoCaos = [
    //     {tenDonVi: store.state.team},
    //   ];
    // }
    // initDb();

    const addReport = () => {
      if(baoCao.value.tuThang == null || baoCao.value.denThang == null)
      {
        toast.add({
          severity: 'error',
          summary: 'Lỗi',
          detail:'Vui lòng chọn thời gian báo cáo',
          life: 2000
        });
      }
      else {
        CDCRepository.createBaoCaoSangLocBenh(baoCao.value)
            .then((response) => {
              const temp = ref({} as BaoCaoSangLocBenhKLN);
              baoCao.value = temp.value;
              toast.add({
                severity: 'success',
                summary: 'Thêm báo cáo',
                detail: 'Thêm báo cáo thành công vào hệ thống',
                life: 2000
              });
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2000
              });
            });
      }
    }

    const selectCalendarSanLoc = () => {
      if((dateSanLoc.value[0] != null)&&(dateSanLoc.value[1] != null))
      {
        listBaoCao.value = [];
        CDCRepository.getListBaoCaoSangLoc(dateSanLoc.value[0]/1000, dateSanLoc.value[1]/1000)
            .then((response) => {
              listBaoCao.value = response.data;
              if(listBaoCao.value.length < 1){
                toast.add({
                  severity: 'warn',
                  summary: 'Báo cáo',
                  detail:'Không tìm thấy báo cáo trong khoản thời gian đã chọn',
                  life: 2500
                })
              }
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:err.response.data,
                life: 2500
              })})
      }
    };

    const loadDBSanLoc = (id) => {
      loadingData.value = true;
      CDCRepository.getBaoCaoSangLocBenhKLNById(id)
          .then((response) => {
            baoCaoSanLoc.value = true;
            baoCao.value = response.data;
            loadingData.value = false;
          })
          .catch(err => {
            loadingData.value = false;
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail: err.response.data,
              life: 2000
            });
          });
    }
    const clearCalendar = () => {
      listBaoCao.value = [];
    }
    const formatDateTime = (date) => {
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format(' DD/MM/YYYY');
    };

    const formatDateTimeHours = (date) => {
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format(' HH:mm DD/MM/YYYY');
    };

    const downloadFile = ref(false);
    const loadingExport = ref(false);
    const loadingBar = ref(false);

    const downLoadFileExport = (file) => {
      axios({
        url: '../api/cdc/downloadLoadFileReport/' + file,
        method: 'GET',
        responseType: 'blob',
      })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], {type: response.data.type}));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "BaoCaoSanLoc.xlsx");
            toast.add({
              severity: 'success',
              summary: 'Xuất dữ liệu',
              detail: 'Xuất dữ liệu thành công',
              life: 2000
            });
            document.body.appendChild(link);
            link.click();
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2500
            })});
    };

    const exportFileSanLoc = () => {
      loadingExport.value = true;
      downloadFile.value = false;
      CDCRepository.exportFileSanLoc(listBaoCao.value)
          .then((response) => {
            loadingExport.value = false;
            downloadFile.value = true
            downLoadFileExport(response.data);
            // router.push({
            //   name: 'home'
            // });
          })
          .catch(err => {
            loadingBar.value = false;
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    return {
      date,
      service,
      addReport,
      baoCao,
      dateSanLoc,
      listBaoCao,
      selectCalendarSanLoc,
      loadDBSanLoc,
      clearCalendar,
      formatDateTimeHours,
      formatDateTime,
      exportFileSanLoc,
      baoCaoSanLoc
    }
  }

}
